import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import QuantityComponent from "../../components/QuantityComponent/QuantityComponent";
import { PhotoSwipe } from "react-photoswipe";
import icons from "../../assets/icons/icons";
import API from "../../config/config";
import httpService from "../../services/httpService";
import { connect } from "react-redux";
import appService from "../../services/appService";
import { formatCurrency } from "../../helpers/utils";
import { eventAddToCart } from "../../helpers/events";
import AffirmPrequalify from "../AffirmPrequalify/AffirmPrequalify";

declare const window: any;

const ProductDetails = ({
  data,
  template,
  onToggle,
  setCartItems,
  showLoader,
  hideLoader,
}: any) => {
  const initValue = {
    quantity: 1,
    productId: data.id,
  };
  const [isclosed, setPopup] = useState(false);
  const [price, setPrice]: any = useState();
  const [affirmprice, setaffirmprice]: any = useState(null);
  const [ProdImg, setProdImg]: any = useState([]);
  const [options, setOptions]: any = useState(initValue);
  const [validated, setValidated] = useState(false);
  const [selectedVariant, setSelectedVariant]: any = useState();
  const [varDescription, setVarDescription]: any = useState(null);
  const [showDescp, setShowDescp] = useState(null);

  const prepareImages = () => {
    let Images = [];
    let variantImages = getImage(data);
    if (variantImages.length > 0) {
      Images.push(...variantImages);
    } else if (data.image) {
      Images.push(data.image);
    }

    if (data.productImages && data.productImages.length > 0) {
      Images.push(...data.productImages);
    }
    setProdImg(Images);
  };

  useEffect(() => {
    try {
      window.affirm.ui.refresh();
    } catch (err) {}
    if (ProdImg.length === 0) {
      prepareImages();
    }
  });

  useEffect(() => {
    if (selectedVariant) {
      prepareImages();
    }
  }, [selectedVariant]);

  useEffect(() => {
    setShowDescp(data.description);
  }, [data]);

  const prodMinMax = (item: any) => {
    let min: any = [];
    if (item.price !== null) {
      if (affirmprice === null) {
        setaffirmprice(item.price);
      }
      return formatCurrency(Math.abs(item.price).toFixed(2));
    } else {
      item.ProductVariant[0].Variants.map((items: any, i: number) => {
        if (items.newPrice) {
          min.push(items.newPrice);
          return null;
        } else {
          min.push(items.price);
          return null;
        }
      });
      const mi = Math.min(...min);
      const ma = Math.max(...min);
      if (affirmprice === null) {
        setaffirmprice(mi);
      }
      return `${formatCurrency(Math.abs(mi).toFixed(2))} - ${formatCurrency(
        Math.abs(ma).toFixed(2)
      )}`;
    }
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 20000, min: 990 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 990, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const CustomDot = ({ onClick, ...rest }: any) => {
    const { index, active } = rest;
    const carouselItems = ProdImg;
    return (
      <div
        style={{
          backgroundImage:
            "url(" + API.baseUrl + carouselItems[index].url + ")",
        }}
        className={active ? "prod-dots active" : "prod-dots inactive"}
        onClick={() => onClick()}
      />
    );
  };

  const photoSwipe = (image: any) => {
    let ImageReturn: { h: number; w: number; src: string }[] = [];
    image.map((img: any) => {
      return ImageReturn.push({
        h: img.height,
        w: img.width,
        src: img.url ? API.baseUrl + img.url : "",
      });
    });
    return ImageReturn;
  };

  const setVariants = (id: any) => {
    let varData: any;
    data.ProductVariant.find(
      (item: any) =>
        (varData = item.Variants.find((itm: any) => {
          return id === itm.value;
        }))
    );

    setSelectedVariant(varData);
    if (varData.description) {
      setVarDescription(varData.description);
    }

    if (varData.price !== null) {
      const price = Math.abs(varData.price).toFixed(2);
      setPrice(data.currency.symbol + price);
      setaffirmprice(varData.price);
    }
  };

  const getImage = (item: any) => {
    if (selectedVariant) {
      return selectedVariant.images;
    }
    if (item.image) {
      return [item.image];
    } else {
      if (item.ProductVariant && item.ProductVariant.length) {
        if (item.ProductVariant[0].Variants[0].images[0]) {
          if (item.ProductVariant[0].Variants.length) {
            if (item.ProductVariant[0].Variants[0].images[0]) {
              return item.ProductVariant[0].Variants[0].images;
            }
          }
        }
      }
    }
  };

  const handleChange = (event: any) => {
    if (event.target.value !== "0") {
      setOptions({
        ...options,
        variantLabel: event.target.name,
        selectedOption: event.target.value,
      });
    }
  };

  const GoogleAnalyticsAddToCart = () => {
    let prod = {};
    let price;
    if (
      selectedVariant &&
      (selectedVariant.newPrice !== null || selectedVariant.price !== null)
    ) {
      price =
        selectedVariant.newPrice !== null
          ? selectedVariant.newPrice
          : selectedVariant.price;
    } else {
      price = data.newPrice !== null ? data.newPrice : data.price;
    }
    if (data.product_categories && data.product_categories.length > 0) {
      let category = "";
      data.product_categories.forEach((element: any, i: number) => {
        if (element.name) {
          category += element.name;
          if (i < data.product_categories.length) {
            category += "/";
          }
        }
      });
      prod = { ...prod, category: category };
    }

    prod = {
      ...prod,
      id: data.id,
      name: data.displayTitle ? data.displayTitle : data.title,
      discount: data.newPrice !== null ? data.price - data.newPrice : 0,
      affiliation: "Nexersys Store",
      brand: "Nexersys",
      // item_category: 'pants',
      price: price,
      currency: data.currency ? data.currency.code : "USD",
      quantity: options.quantity,
    };

    if (selectedVariant) {
      prod = { ...prod, variant: selectedVariant.value };
    }

    const item = {
      currency: "USD",
      items: [prod],
      value: price,
    };
    eventAddToCart(item);
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    // event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity()) {
      GoogleAnalyticsAddToCart();
      const cartid = appService.getKey("cartid");
      showLoader();
      httpService.invokeApi(
        {
          url: `${API.endpoints.getCart}/${cartid}/cartitems`,
          method: "put",
          data: options,
        },
        (success: boolean, res: any) => {
          if (success && res.id) {
            const request: any = { method: "get", url: API.endpoints.getCart };
            if (cartid) {
              request.headers = { cartid: cartid };
            }
            httpService.invokeApi(request, (success: boolean, res: any) => {
              if (success) {
                appService.setKey("cartid", res.cartId);
                setCartItems(res);
                onToggle();
                hideLoader();
              } else {
                hideLoader();
              }
            });
          } else {
            hideLoader();
          }
        }
      );
    } else {
      setValidated(false);
    }
  };

  return (
    data &&
    template && (
      <div className="product-details-view-container">
        <div className="container">
          <Row lg={2} xs={1} sm={1}>
            <Col
              lg={{ order: template.productImageAlignment === "left" ? 1 : 2 }}
              className="pos-rel"
            >
              {ProdImg.length > 0 && (
                <Carousel
                  responsive={responsive}
                  ssr={true}
                  infinite={ProdImg.length > 1 ? true : false}
                  showDots={ProdImg.length > 1 ? true : false}
                  renderDotsOutside
                  arrows={false}
                  keyBoardControl
                  transitionDuration={0.5}
                  containerClass="carousel-container"
                  dotListClass="custom-dot-list-style"
                  itemClass="carousel-item-padding-40-px"
                  customDot={<CustomDot />}
                >
                  {ProdImg.map((item: any, i: number) => {
                    return (
                      <div
                        key={i}
                        className="prod-image"
                        style={{
                          backgroundImage: `url(${
                            item.url ? API.baseUrl + item.url : ""
                          })`,
                        }}
                      />
                    );
                  })}
                </Carousel>
              )}
              <div
                onClick={() => {
                  setPopup(!isclosed);
                }}
                className={"prod-search-icon"}
              >
                {icons.search("#000", "fa-sm")}
              </div>
            </Col>
            <Col
              lg={{
                order: template.productDetailsAlignment === "right" ? 2 : 1,
              }}
            >
              {data.displayTitle && <h1>{data.displayTitle}</h1>}
              <div>
                {data.currency && (
                  <h4>
                    {data.currency.symbol}
                    {prodMinMax(data)}
                  </h4>
                )}
                {data.price > 0 && data.price && (
                  <div className="CardProductSale-affirm single-product-pre">
                    <AffirmPrequalify price={data.price} newPrice={data?.newPrice} />
                  </div>
                )}
                <div className="features-adjust">
                  {data.Features && (
                    <div className="features-pre">
                      <h3>{data.Features?.label}</h3>
                      <p>{data.Features?.note}</p>
                    </div>
                  )}
                  {data.Specifications && (
                    <>
                      <h3>{data.Specifications?.label}</h3>
                      <p>{data.Specifications?.note}</p>
                    </>
                  )}
                  {data.ProductKeyFeatures &&
                    data.ProductKeyFeatures?.KeyFeatures && (
                      <div className="comes-with-spec">
                        <h3>{data.ProductKeyFeatures.label}</h3>
                        <ul>
                          {data.ProductKeyFeatures?.KeyFeatures?.length > 0 &&
                            data.ProductKeyFeatures.KeyFeatures.map(
                              (item, index) => <li key={index}>{item.title}</li>
                            )}
                        </ul>
                      </div>
                    )}
                  {data.AdditionalInfo &&
                    data.AdditionalInfo?.length > 0 &&
                    data.AdditionalInfo?.map((item, index) => (
                      <div key={index} className="additional-info-descp">
                        <h3>{item?.label}</h3>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      </div>
                    ))}
                </div>
              </div>

              <Form
                onChange={handleChange}
                onSubmit={handleSubmit}
                validated={validated}
              >
                {data.ProductVariant &&
                  data.ProductVariant.length > 0 &&
                  data.ProductVariant.map((item: any, i: number) => {
                    return (
                      item && (
                        <div key={i} className="display-flex">
                          {item.label && (
                            <div className="form-label app-bold-label">
                              {item.label}
                            </div>
                          )}
                          <Form.Control
                            aria-label="Choose a option"
                            as="select"
                            onChange={(event) => {
                              if (event.target.value) {
                                setVariants(event.target.value);
                              } else {
                                setVarDescription(false);
                                setShowDescp(null);
                                setPrice(null);
                              }
                            }}
                            name={item.label}
                            required
                          >
                            <option value={""}>Choose a option</option>
                            {item.Variants &&
                              item.Variants.map((data: any, i: number) => {
                                return (
                                  data &&
                                  data.value && (
                                    <option key={i} value={data.value}>
                                      {data.value}
                                    </option>
                                  )
                                );
                              })}
                          </Form.Control>
                          <div className="invalid-feedback">
                            Choose an Option
                          </div>
                        </div>
                      )
                    );
                  })}
                {showDescp && (
                  <p
                    className="accessories-desc-ul"
                    dangerouslySetInnerHTML={{ __html: showDescp }}
                  />
                )}
                {varDescription && (
                  <p
                    className="variant-desc"
                    dangerouslySetInnerHTML={{ __html: varDescription }}
                  />
                )}
                {price && (
                  <div className="form-label label-price">
                    {price ? formatCurrency(price) : null}
                  </div>
                )}
                <div className="input-add-to-button">
                  {data.tangible && (
                    <QuantityComponent
                      onChange={(quantity: number) => {
                        setOptions({ ...options, quantity: quantity });
                      }}
                      enableZero={false}
                    />
                  )}
                  <button
                    type="submit"
                    className="add-to-cart-button focus-visible"
                    tabIndex={0}
                  >
                    Add to Cart{" "}
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
        {ProdImg && ProdImg.length > 0 && (
          <PhotoSwipe
            items={photoSwipe(ProdImg)}
            isOpen={isclosed}
            onClose={() => {
              setPopup(!isclosed);
            }}
          />
        )}
      </div>
    )
  );
};

const mapState = (state: any) => {
  return {
    status: state.cartStatus,
    cart: state.cart,
  };
};

const mapDispatch = (dispatch: any) => {
  return {
    onToggle: () => dispatch({ type: "TOGGLE_CART" }),
    setCartItems: (cartItems: any) => {
      dispatch({ type: "ON_CART_LOAD", payload: cartItems });
    },
    showLoader: () => dispatch({ type: "LOADER_SHOW" }),
    hideLoader: () => dispatch({ type: "LOADER_HIDE" }),
  };
};

export default connect(mapState, mapDispatch)(ProductDetails);
